import React, { useState } from 'react';
import { FormControl, FormLabel, Input, Flex } from '@chakra-ui/react';
import { CloseIcon, EditIcon } from '@chakra-ui/icons';

interface EditableFieldProps {
  id: string;
  label: string;
  value: string|number;
  // This will tell if the page is create or edit
  isEditing: boolean;
  type?: string;
  onEdit: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const EditableInputText: React.FC<EditableFieldProps> = ({ id, label, value, isEditing, type = 'text', onEdit }) => {
  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <FormControl id={id} mb={4}>
      {/* {if in create page} */}
      {!isEditing && (
        <>
          <FormLabel>{label}</FormLabel>
          <Input type={type} value={value} onChange={onEdit} />
        </>
      )}

      {/* {if in edit page and edit mode is on} */}
      {isEditing && isEditMode && (
        <>
          <Flex justifyContent="space-between" alignItems="center">
            <FormLabel>{label}</FormLabel>
            {isEditing && <CloseIcon onClick={() => setIsEditMode(!isEditMode)} />}
          </Flex>
          <Input type={type} value={value} onChange={onEdit} />
        </>
      )}

      {/* {if in edit page and edit mode is off} */}
      {isEditing && !isEditMode && (
        <>
          <Flex justifyContent="space-between" alignItems="center">
            <FormLabel>{label}</FormLabel>
            {isEditing && <EditIcon onClick={() => setIsEditMode(!isEditMode)} />}
          </Flex>
          <Input readOnly type={type} value={value} />
        </>
      )}
    </FormControl>
  );
};

export default EditableInputText;
